/* eslint-disable no-param-reassign */
/**
 * Waits for a ref property to become truthy
 * @param {Object} ref - React ref object
 * @param {string} key - Property key to wait for
 * @param {boolean} skip - Skip waiting if true
 * @param {number} timeout - Timeout in milliseconds
 * @returns {Promise} Resolves when ref[key] becomes truthy
 */
export const waitForRefValue = (ref, key, skip = false, timeout = 10000) => {
  return new Promise((resolve, reject) => {
    if (ref.current[key] || skip) resolve();
    else if (ref.current.resolver) reject(new Error('Ref already has resolver'));
    else {
      const timeoutId = setTimeout(() => {
        ref.current.resolver = null;
        reject(new Error(`Ref failed to resolve after ${timeout}`));
      }, timeout);

      ref.current.resolver = () => {
        clearTimeout(timeoutId);
        resolve();
        ref.current.resolver = null;
      };
    }
  });
};

// Fisher-Yates shuffle algorithm
const shuffle = (arr) => {
  let endI = arr.length - 1;

  while (endI) {
    let randI = Math.floor(Math.random() * endI);
    // eslint-disable-next-line no-param-reassign
    [arr[endI], arr[randI]] = [arr[randI], arr[endI]];
    endI -= 1;
  }

  return arr;
};

export const getRandomElements = (list, items = 3) => shuffle([...list]).slice(0, items);

export const checkGenerateQuestionsNeeded = ({
  savedMessages,
  channel,
  isConsumerApp,
  isDynamicIsqMasterEnabled,
  isDynamicIsqDtFsEnabled,
  isDynamicIsqMwFsEnabled,
  isDynamicIsqAppFsEnabled
}) => {
  const isDesktop = channel === 'desktop';
  const isMobile = channel === 'mobile' && !isConsumerApp;
  const initialMessage = savedMessages.find((msg) => msg.isInitialMessage);

  const hasCustomerInteracted = savedMessages.length > 1;
  const isISQExistsForInitialMessage = initialMessage?.content?.suggestedQuestions?.length > 0;

  if (isISQExistsForInitialMessage || hasCustomerInteracted) return false;

  // Fetch flags to determine if we should call generate questions
  const enableForDesktop = isDesktop && isDynamicIsqDtFsEnabled;
  const enableForMobile = isMobile && isDynamicIsqMwFsEnabled;
  const enableForApp = isConsumerApp && isDynamicIsqAppFsEnabled;
  const shouldCallGenerateQuestions = isDynamicIsqMasterEnabled
    && (enableForDesktop || enableForMobile || enableForApp);
  return shouldCallGenerateQuestions;
};